<template>
	<div class="after-search-body">
		<div class="after-search-wrap">
			<div class="filters-box-row" :style="collapse ? 'height: 50px' : ''">
				<div class="input-box">
					<el-select v-model="dateType" class="select-input" size='small'>
						<el-option :value="3" label="售后时间"></el-option>
						<el-option :value="2" label="备货时间"></el-option>
						<el-option :value="0" label="下单时间"></el-option>
						<el-option :value="1" label="期望到货时间"></el-option>
					</el-select>
					<el-date-picker
						@change="searchTime"
						v-model="dateValue"
						:clearable="false"
						:unlink-panels='true'
						:default-time="['00:00:00', '23:59:59']"
						class="time-input"
						size="small"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm'>
					</el-date-picker>
				</div>
				<div class="input-box">
					<span>客户类别：</span>
					<el-select v-model="customerCategoryId" class="search-input" size='small'>
						<el-option value="0" label="全部"></el-option>
						<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>客户名称：</span>
					<el-input
						class="search-input"
						v-model="customerName"
						placeholder="请输入客户名称/编号"
						size="small"
						maxlength="50"
						@keyup.enter.native="search">
					</el-input>
				</div>
				<div class="input-box">
					<span>关联订单号：</span>
					<el-input
						class="search-input"
						v-model="orderNumber"
						placeholder="请输入关联订单号"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
				<div class="input-box">
					<span>订单状态：</span>
					<el-select v-model="orderStatus" class="search-input" size='small'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="3" label="待收货"></el-option>
						<el-option :value="4" label="已完成"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>售后单号：</span>
					<el-input
						class="search-input"
						v-model="afterSaleNumber"
						placeholder="请输入售后单号"
						size="small"
						maxlength="20"
						@keyup.enter.native="search">
					</el-input>
				</div>
				<div class="input-box">
					<span>售后商品：</span>
					<el-input
						class="search-input"
						v-model="productName"
						placeholder="请输入商品名称或编码"
						size="small"
						maxlength="20"
						@keyup.enter.native="search">
					</el-input>
				</div>
				<div class="input-box">
					<span style="display: inline-block;text-indent: 1em;">售后分类：</span>
					<el-select v-model="afterSaleTypeId" class="search-input" size='small' clearable filterable>
						<el-option v-for="item in afterSaleType" :value="item.id" :label="item.value" :key="item.id"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>责任部门：</span>
					<el-select v-model="deptId" class="search-input" size='small' clearable filterable>
						<el-option v-for="item in dept" :value="item.id" :label="item.value" :key="item.id"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>处理方式：</span>
					<el-select v-model="dealTypeId" class="search-input" size='small' clearable filterable>
						<el-option v-for="item in dealType" :value="item.id" :label="item.value" :key="item.id"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span style="display: inline-block;text-indent: 2em;">备注：</span>
					<el-input
						class="search-input"
						v-model="memo"
						placeholder="请输入备注"
						size="small"
						maxlength="20"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="after-search-right" style="position:relative">
				<el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
				</el-button>
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="filters-box-row filters-box-row3">
			<!-- <el-button size="small" type="primary" plain class="btn fx-btn" style="margin-left: 0px" icon="el-icon-printer" @click="printerEvent">打印</el-button> -->
			<el-button size="small" type="primary" class="btn fx-btn" style="margin-left: 0px" v-if="AuthorityList['07_0005_0002_00']" @click="goValet">新建售后单</el-button>
			<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" @click="exportExcel">
				<div></div>
				导出
			</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	components: {
		// Print
	},
	props: {
		active: {
			type: String
		},
		clearing: {
			type: String,
			default: '0'
		},
		// origin: {
		// 	type: String,
		// 	default: ''
		// },
		clddock: {
			type: Number,
			default: 0
		},
		ids: {
			type: Array,
			default: () => []
		},
		customList: {
			type: Array,
			default: () => []
		},
		lineList: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		},
		needauditingflag: Boolean
	},
	data () {
		return {
			dateValue: [],
			orderNumber: '',
			collapse: false,
			dateType: 3,
			customerCategoryId: '0',
			productName: '',
			customerName: '',
			orderStatus: -1,
			afterSaleNumber: '',
			afterSaleTypeId: '',
			deptId: '',
			dealTypeId: '',
			memo: '',
			afterSaleType: [],
			dealType: [],
			dept: [],
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		if (window.sessionStorage.getItem('afterSelect') && !this.filterFlag) {
			let data = JSON.parse(window.sessionStorage.getItem('afterSelect'))
			this.dateValue = data.dateValue
			this.orderNumber = data.orderNumber
			this.dateType = data.dateType
			this.customerCategoryId = data.customerCategoryId
			this.productName = data.productName
			this.customerName = data.customerName
			this.orderStatus = data.orderStatus
			this.afterSaleNumber = data.afterSaleNumber
			this.afterSaleTypeId = data.afterSaleTypeId
			this.deptId = data.deptId
			this.dealTypeId = data.dealTypeId
			this.memo = data.memo
		}
		if (window.sessionStorage.getItem('afterSearchTime') && !this.filterFlag) {
			this.dateValue = JSON.parse(window.sessionStorage.getItem('afterSearchTime'))
		} else {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
		}
		this.getAfterSaleManager()
	},
	methods: {
		// 售后分类/责任部门/处理方式
		getAfterSaleManager () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/findAllAfterSaleManagerValue`
			}).then(res => {
				if (res.result === true) {
					this.afterSaleType = res.data.afterSaleType
					this.dept = res.data.dept
					this.dealType = res.data.dealType
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		goValet () {
			this.$router.push(`/main/afterSaleOrder`)
		},
		searchTime (value) {
			if (!this.filterFlag) {
				window.sessionStorage.setItem('afterSearchTime', JSON.stringify(value))
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue.length === 0) {
				this.$message.error('请选择正确时间范围！')
				return false
			}
			var begintime = this.dateValue[0]
			var endtime = this.dateValue[1]
			// 判断时间跨度是否大于6个月
			var arr1 = begintime.split('-')
			var arr2 = endtime.split('-')
			arr1[1] = parseInt(arr1[1])
			arr1[2] = parseInt(arr1[2])
			arr2[1] = parseInt(arr2[1])
			arr2[2] = parseInt(arr2[2])
			var flag = true
			if (arr2[0] - arr1[0] > 1) {
				flag = false
			} else if (arr2[0] - arr1[0] === 1) {
				if (arr1[1] < arr2[1]) { // 月相隔大于12个月
					flag = false
				} else if (arr1[1] === arr2[1]) { // 月相隔12个月，比较日
					if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
						flag = false
					}
				}
			}
			if (!flag) {
				this.$message.error('时间范围不得超过12个月！')
				return false
			}
			return true
		},
		search () {
			// this.dateValue = this.dateValue === null ? [] : this.dateValue
			console.log(this.dateValue)
			if (this.checkTime()) {
				this.$emit('handleSearch', { customerCategoryId: this.customerCategoryId, productName: this.productName, customerName: this.customerName, dateValue: this.dateValue, orderNumber: this.orderNumber, dateType: this.dateType, orderStatus: this.orderStatus, afterSaleNumber: this.afterSaleNumber, afterSaleTypeId: this.afterSaleTypeId, deptId: this.deptId, dealTypeId: this.dealTypeId, memo: this.memo })
			}
		},
		// 导出
		exportExcel () {
			this.$emit('exportExcel')
		},
		clear () {
			let value = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.searchTime(value)
			this.clearAllInput()
			this.search()
		},
		clearInput () {
			this.orderNumber = ''
			this.customerCategoryId = '0'
			this.productName = ''
			this.customerName = ''
			this.orderNumber = ''
			this.dateType = 3
			this.orderStatus = -1
			this.afterSaleNumber = ''
			this.afterSaleTypeId = ''
			this.deptId = ''
			this.dealTypeId = ''
			this.memo = ''
		},
		clearAllInput () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.orderNumber = ''
			this.customerCategoryId = '0'
			this.productName = ''
			this.customerName = ''
			this.orderNumber = ''
			this.dateType = 3
			this.orderStatus = -1
			this.afterSaleNumber = ''
			this.afterSaleTypeId = ''
			this.deptId = ''
			this.dealTypeId = ''
			this.memo = ''
		}
	}
}
</script>

<style lang="stylus" scoped>
.after-search-body {
	.after-search-wrap {
		display: flex;
		justify-content: space-between
	}
	.filters-box-row {
		display: flex;
		// width :100%;
		line-height :50px;
		flex-wrap: wrap;
		overflow: hidden;
		// min-width :600px;
		box-sizing: border-box
		text-align: left
		.select-input {
			width: 125px!important;
		}
		.search-input {
			width: 150px;
		}
		.time-input {
			margin-left: 5px;
			width: 430px;
		}
		.input-box {
			// margin-right: 10px
			&>span {
				display: inline-block;
				width: 130px;
				text-align: right
			}
		}
		&.filters-box-row3 {
			padding-top: 5px;
			height: 50px
		}
	}
	.after-search-right {
		width: 200px;
		flex-shrink: 0;
		margin-left: 20px;
		line-height: 50px
	}
}
</style>
<style lang="stylus">
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
</style>
